import { formService } from '@common/lib/modules/form';
import { MaxPartExamQuantityValidator } from '../modules/post-graduate-education-template/validators';
import { EducationElementRequiredValidator } from '../modules/person/validators';
import { EducationMonthUniqueValidator } from '../modules/monthly-data-entry/validators';

export const registerValidators = () => {
  formService.registerValidator('maxPartExamQuantity', MaxPartExamQuantityValidator);
  formService.registerValidator('educationElementRequired', EducationElementRequiredValidator);
  formService.registerValidator('educationMonthUnique', EducationMonthUniqueValidator);
};

export const initForms = () => {
  registerValidators();
};
